import React from "react";
import { useModalTrackingViewHook } from "./modal-tracking-view-hooks";

type ContextModalTrackingView = ReturnType<typeof useModalTrackingViewHook>;
export const ModalTrackingViewContext =
  React.createContext<ContextModalTrackingView | null>(null);

export function useContextModalTrackingView() {
  const context = React.useContext(ModalTrackingViewContext);

  if (!context) {
    throw new Error(
      "useContextModalTrackingView must be used within a ContextModalTrackingViewProvider",
    );
  }

  return context;
}
